/**
 * Shared "liquid glass" surfaces (Apple-style translucent blur).
 * Use with MUI `sx={glassPanel}` etc.
 */

export const glassPanel = {
  background: "rgba(255, 255, 255, 0.52)",
  backdropFilter: "blur(28px) saturate(190%)",
  WebkitBackdropFilter: "blur(28px) saturate(190%)",
  border: "1px solid rgba(255, 255, 255, 0.65)",
  boxShadow: `
    0 4px 24px rgba(0, 0, 0, 0.06),
    inset 0 1px 0 rgba(255, 255, 255, 0.75)
  `,
};

export const glassPanelStrong = {
  ...glassPanel,
  background: "rgba(255, 255, 255, 0.72)",
  backdropFilter: "blur(40px) saturate(200%)",
  WebkitBackdropFilter: "blur(40px) saturate(200%)",
};

export const glassNav = {
  background: "rgba(22, 22, 24, 0.58)",
  backdropFilter: "blur(48px) saturate(200%)",
  WebkitBackdropFilter: "blur(48px) saturate(200%)",
  borderTop: "1px solid rgba(255, 255, 255, 0.14)",
  boxShadow: "0 -8px 32px rgba(0, 0, 0, 0.12)",
};

/** Fixed app chrome at top — same liquid-glass language as `glassAuthCard` (bright frost, specular edges, lawn-tinted shadow). */
export const glassTopNav = {
  background: `
    linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.55) 45%, rgba(248, 252, 250, 0.78) 100%)
  `,
  backdropFilter: "blur(48px) saturate(205%)",
  WebkitBackdropFilter: "blur(48px) saturate(205%)",
  borderBottom: "1px solid rgba(255, 255, 255, 0.88)",
  boxShadow: `
    inset 0 1px 1px rgba(255, 255, 255, 0.95),
    inset 0 -1px 0 rgba(255, 255, 255, 0.45),
    0 10px 40px rgba(12, 48, 28, 0.12),
    0 4px 16px rgba(0, 0, 0, 0.06)
  `,
};

/** Mobile nav dropdown — matches `glassAuthCard` / top bar (light frost, not dark chrome). */
export const glassTopNavMenuPaper = {
  background: `
    linear-gradient(145deg, rgba(255, 255, 255, 0.94) 0%, rgba(255, 255, 255, 0.58) 40%, rgba(248, 252, 250, 0.85) 100%)
  `,
  backdropFilter: "blur(48px) saturate(205%)",
  WebkitBackdropFilter: "blur(48px) saturate(205%)",
  border: "1px solid rgba(255, 255, 255, 0.88)",
  boxShadow: `
    inset 0 1px 1px rgba(255, 255, 255, 0.95),
    inset 0 -1px 0 rgba(255, 255, 255, 0.35),
    0 28px 64px rgba(12, 48, 28, 0.16),
    0 8px 28px rgba(0, 0, 0, 0.08)
  `,
};

/** Login / sign-up hero card — bright frosted panel over photography. */
export const glassAuthCard = {
  background: `
    linear-gradient(145deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 255, 255, 0.52) 42%, rgba(248, 252, 250, 0.72) 100%)
  `,
  backdropFilter: "blur(48px) saturate(205%)",
  WebkitBackdropFilter: "blur(48px) saturate(205%)",
  border: "1px solid rgba(255, 255, 255, 0.88)",
  boxShadow: `
    inset 0 1px 1px rgba(255, 255, 255, 0.95),
    inset 0 -1px 0 rgba(255, 255, 255, 0.4),
    0 28px 72px rgba(12, 48, 28, 0.2),
    0 8px 28px rgba(0, 0, 0, 0.1)
  `,
};

export const glassDropdown = {
  ...glassPanelStrong,
  borderRadius: 8,
  overflow: "hidden",
  mt: 0.5,
  maxHeight: 280,
  overflowY: "auto",
  overflowX: "hidden",
  boxShadow: `
    0 12px 40px rgba(0, 0, 0, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.85)
  `,
};

export const glassTextField = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 14,
    backgroundColor: "rgba(255, 255, 255, 0.55)",
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    transition: "box-shadow 0.2s ease, background-color 0.2s ease",
    "& fieldset": {
      borderColor: "rgba(255, 255, 255, 0.7)",
    },
    "&:hover fieldset": {
      borderColor: "rgba(255, 255, 255, 0.95)",
    },
    "&.Mui-focused": {
      backgroundColor: "rgba(255, 255, 255, 0.78)",
      boxShadow: "0 0 0 3px rgba(45, 106, 79, 0.22)",
      "& fieldset": {
        borderColor: "rgba(45, 106, 79, 0.45)",
      },
    },
  },
};
